import React from "react";
import { CalendarTwoTone, InboxOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import Sidenav from "../../component/sidenav";
import "./import.scss";
import { Button, message, Upload } from "antd";
import sample from "../../assets/docs/sample.xlsx";

function Import() {
  const { Dragger } = Upload;
  const query = useHistory().location.search;
  const token = new URLSearchParams(query).get("token");

  const props = {
    name: "file",
    multiple: false,
    action: `${process.env.REACT_APP_API_URL}/import?token=${token}`,
    onChange(info) {
      const { status } = info.file;
      if (status === "done") {
        const { success, message: eInfo } = info.file.response;
        if (success === true) {
          message.success(`${info.file.name} file uploaded successfully.`);
        } else if (success === false) {
          message.error(`${info.file.name} file upload failed. ${eInfo}`);
        }
      } else if (status === "error") {
        if (
          info.file?.response?.statusCode &&
          info.file?.response?.statusCode === 402
        ) {
          window.location.href = `/subscriptions?token=${token}`;
        } else {
          message.error(`${info.file.name} file upload failed.`);
        }
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  return (
    <div className="d-flex  ">
      <Sidenav />
      <div className="flex-1 import p-5">
        <div>
          Here is the sample file for Import
          <Button
            href={sample}
            color="transparent"
            target="_blank"
            className="download-btn"
            download
            data-telemetry="Download sample file to import"
          >
            Download
          </Button>
        </div>
        <br />
        <div>
          <Button
            href="https://booking.setmore.com/scheduleappointment/779308dc-adca-4381-9621-3a92a6910fd3"
            color="transparent"
            target="_blank"
            className="download-btn"
            data-telemetry="Import: We can help!"
          >
            We can help!
          </Button>
        </div>
        <br />
        <br />
        <Dragger {...props}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">Click or drag a file to upload.</p>
          <p className="ant-upload-hint">
            You can find the file format for import here:{" "}
            <strong>
              '.xlsx', '.xlsm', '.xlsb', '.xltx', '.xltm', '.xls', '.xlt'
            </strong>
          </p>
        </Dragger>
      </div>
    </div>
  );
}

export default Import;
